<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 font-45 colorPrincipal">
            CLORINDA MATTO<br>
            DE TURNER <br>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio9/clorindaMatto">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio10/clorindaMatto">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio10/clorindaMatto">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img001.jpg">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="text-center fontMS500 font-24">
                    CLORINDA MATTO DE TURNER ES MUY CONOCIDA POR SU NOVELA <span class="fontMS500Italic">AVES SIN
                        NIDO</span>, OBRA QUE FORMA PARTE DE LOS INICIOS DEL INDIGENISMO LITERARIO EN EL PAÍS. 
                        PERO ADEMÁS TUVO UNA PROLÍFICA TRAYECTORIA COMO ENSAYISTA, MAESTRA, TRADUCTORA, EDITORA 
                        Y PERIODISTA DURANTE UNO DE LOS PERIODOS MÁS TURBULENTOS DE LA HISTORIA REPUBLICANA. 
                        CLORINDA MATTO SE POSICIONA EN ESPACIOS NUNCA ANTES OCUPADOS POR MUJERES Y UTILIZA SU 
                        PLATAFORMA PARA REIVINDICAR EL LUGAR DE LAS MUJERES Y LOS INDÍGENAS EN LA SOCIEDAD PERUANA.
                    <br>
                </p>
                <div class="row">
                    <div class="col-sm-6 text-right">
                        <div class="libro">
                            <a href="http://hdl.handle.net/20.500.14428/79175" style="color: inherit;" target="_blank">
                                <img class="img-fluid imgNP" width="80%"
                                    src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img002.jpg">
                                <div class="overlay2">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Clorinda Matto de Turner.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            <br>
                                        </span>
                                        Estudio Courret, ca. 1887
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 font-24 text-gris">
                            <br>
                            A continuación presentamos una serie de documentos que nos ofrecen un acercamiento a la
                             vida y obra de esta pensadora peruana. La selección incluye la primera edición de 
                             <span class="fontMS100Italic"> Aves sin nido, </span> y otras publicaciones menos 
                             conocidas como su escrito biográfico sobre el Doctor Lunarejo o su traducción de un 
                             evangelio al quechua. Igualmente se destacan el muestrario de la imprenta “La Equitativa”, 
                             fundada por Clorinda Matto y servida exclusivamente por mujeres, y dos de los periódicos 
                             dirigidos por esta intrépida periodista. La selección culmina con una muestra de su 
                             correspondencia con Ricardo Palma. Sus cartas abarcan, tanto temas personales como profesionales, 
                             y dan a conocer las muchas dificultades que Clorinda Matto enfrentó a fines del siglo XIX, 
                             por el hecho de “ser mujer en el Perú”.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container_Gris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;margin-top: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            DEFENSORA DEL QUECHUA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-38">
                    Y LA CULTURA CUSQUEÑA
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%" style="margin-top: 2%;"
                        src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br>
                    CLORINDA MATTO APRENDIÓ A HABLAR QUECHUA DESDE MUY JOVEN, EN LA HACIENDA CUSQUEÑA DONDE PASÓ GRAN PARTE DE SU NIÑEZ. 
                    FUE EN ESA ÉPOCA EN QUE DESARROLLO UNA PROFUNDA ADMIRACIÓN POR EL IDIOMA Y LA COSMOVISIÓN ANDINA. MÁS TARDE PROFUNDIZÓ 
                    ESTE CONOCIMIENTO A TRAVÉS DEL ESTUDIO DE AUTORES DE LA ÉPOCA COLONIAL COMO EL INCA GARCILASO, EL DOCTOR LUNAREJO 
                    O EL CRONISTA BLAS VALERA.
                </p>
                <p class="fontMS100 text-justify font-24">
                    <br>
                    A partir de estas experiencias, Clorinda Matto reivindica la importancia de la historia y cultura 
                    cusqueña. Esta labor no culmina en sus  <span class="fontMS100Italic">Tradiciones cuzqueñas</span>,
                    sino que es uno de los hilos conductores de toda su obra. Entre otros aportes, rescata el legado de 
                    Juan de Espinoza Medrano, el Lunarejo, uno de los máximos representantes del barroco peruano. En los 
                    círculos intelectuales más representativos de la capital, destacó la importancia del quechua para la 
                    Nación, y los últimos años de su vida, realizó una serie de traducciones de la Biblia al quechua.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-3 libro text-center">
                        <a href="https://hdl.handle.net/20.500.14428/71823" style="color: inherit;" target="_blank">
                            <img class="img-fluid imgNP_sp" width="100%"
                                src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img003.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Clorinda Matto de Turner.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Estudios históricos. En Leyendas y recortes.
                                        <br>
                                    </span>
                                    Imprenta La Equitativa, 1893.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro text-center">
                        <a href="https://hdl.handle.net/20.500.14428/46959" style="color: inherit;" target="_blank">
                            <img class="img-fluid imgNP_sp" width="100%"
                                src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img004.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Clorinda Matto de Turner.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Don Juan de Espinosa Medrano ó sea el Doctor Lunarejo: estudio biográfico.
                                        <br>
                                    </span>
                                    Imprenta de Carlos Prince, 1887.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro text-center">
                        <a href="https://hdl.handle.net/20.500.14428/62560" style="color: inherit;" target="_blank">
                            <img class="img-fluid imgNP_sp" width="100%"
                                src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img005.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Clorinda Matto de Turner.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Apunchis Jesucristoc evangelion San Lucaspa Qquelkascan.
                                        <br>
                                    </span>
                                    Imprenta El Progreso, 1912.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro text-center">
                        <a href="http://hdl.handle.net/20.500.14428/79319 " style="color: inherit;" target="_blank">
                            <img class="img-fluid imgNP_sp" width="100%"
                                src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img006.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Clorinda Matto de Turner.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Estudios históricos. En Leyendas y recortes.
                                        <br>
                                    </span>
                                    Imprenta La Equitativa, 1893.
                                </p>
                            </div>
                        </a>
                    </div>
                    <br><br>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container_Blanco_Img">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 150%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-40">
                            PERIODISMO Y
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 colorPrincipal font-40">
                    CRÍTICA SOCIAL
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%" style="margin-top: 2%;"
                        src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                </div>
                <p class="fontMS500 font-24">
                    <br>
                    ENTRE LAS PIONERAS DEL PERIODISMO EN EL PAÍS, SE DESTACA LA TRAYECTORIA DE CLORINDA MATTO. 
                    NO SOLO EJERCE DICHA PROFESIÓN COMO COLABORADORA, SINO QUE LLEGA A OCUPAR ESPACIOS NUNCA 
                    ANTES OCUPADOS POR OTRAS MUJERES.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/70117" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="80%"
                                    src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img007.jpg">
                                <div class="overlay3">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            El Recreo,
                                        </span>
                                        números 1-24, 1876-1877.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br><br>
                        <div class="libro">
                            <a href="http://hdl.handle.net/20.500.14428/79059" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP_sp" width="80%"
                                    src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img008.jpg">
                                <div class="overlay3a">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            El Perú Ilustrado,
                                        </span>
                                        números 1-84, 1874.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify font-24">
                            <br>
                            Es fundadora y directora de <span class="fontMS100Italic">El Recreo</span> en Cuzco
                            (1876-1887) y
                            <span class="fontMS100Italic">Los Andes</span>, publicado en Lima y distribuido en varias
                            regiones (1893-1895). En Arequipa sirve
                            como jefa de redacción en el diario <span class="fontMS100Italic">La Bolsa</span>
                            (1884-1885) y en Lima se desempeña como
                            directora del distinguido semanario <span class="fontMS100Italic">El Perú Ilustrado</span>
                            (1889-1891). Nunca abandona la
                            vocación, ni en el exilio. En Buenos Aires dirige la revista <span
                                class="fontMS100Italic">El Búcaro Americano</span> hasta los
                            últimos años de su vida.
                            <br><br>
                            Para Clorinda Matto, el periodismo se convirtió en un espacio para realizar la crítica social. 
                            Por su postura a favor de la libertad de prensa y su incansable crítica de los abusos del clero, 
                            y por sus afiliaciones políticas, enfrentó severas consecuencias, desde la prohibición de sus 
                            obras hasta la destrucción de su hogar e imprenta. Pero nunca se rindió. Durante toda su vida 
                            demostró ser audaz e infatigable. Durante su larga carrera como periodista constantemente creó 
                            espacios para pensar el futuro del país y denunciar la marginación tanto del indígena como de la mujer.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container_Gris_Img">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-40">
                            AVES SIN NIDO
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img class="LineSubsec_Izq2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 colorPrincipal font-40">
                    Y LOS INICIOS <br> DEL INDIGENISMO LITERARIO
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%" style="margin-top: 2%;"
                        src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS500 font-24">
                            EN 1889 CLORINDA MATTO PUBLICÓ SU PRIMERA NOVELA, <span class="fontMS500Italic">AVES SIN 
                                NIDO</span>, LA CUAL SE CONVIERTIÓ EN UN ÉXITO EDITORIAL. EN MUY POCOS AÑOS SE EDITA 
                                EN ARGENTINA, ESPAÑA E INGLATERRA Y SALE UNA SEGUNDA EDICIÓN EN EL PERÚ. DEBIDO A SU POSTURA 
                            ANTICLERICAL, LA NOVELA PROVOCÓ LA IRA DE LOS SECTORES CONSERVADORES DE LA SOCIEDAD Y LA 
                            IGLESIA CATÓLICA. SE PROHIBIÓ SU LECTURA Y SE QUEMARON SUS EJEMPLARES, Y LA AUTORA RECIBIÓ 
                            INSULTOS Y AMENAZAS.
                        </p>
                        <p class="fontMS100 text-left font-24">
                            <br>
                            ¿Por qué resultó tan polémica esta novela? Antes que nada, se convirtió en una revelación 
                            del sufrimiento de los indígenas de la región andina y en una denuncia contra de las 
                            autoridades provinciales, tanto políticas como religiosas. En el proemio de la novela, 
                            la autora vincula su obra con la corriente naturalista que retrataba los vicios y las 
                            virtudes de un pueblo con la intención de provocar empatía en el lector y la necesaria 
                            acción correctiva en la sociedad.
                            <br><br>
                            Aunque las soluciones presentadas en la novela ameritan escrutinio, el espíritu de 
                            denuncia transmitido por Clorinda Matto hace que <span class="fontMS100Italic">Aves sin 
                            </span>nido sea un texto fundacional del indigenismo literario.
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/71817"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img009.jpg">
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container_Azul">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img width="100%" src="\assets\images\general\LINEA_RESALTE_BLANCA.png">
                <br><br><br>
                <p class="fontMS500 text-white text-justify font-24">
                    <span class="fontMS300Italic text-white font-24">AVES SIN NIDO </span>LLEGÓ A SER, SIN EXAGERAR, 
                    LA NOVELA MÁS LEÍDA Y COMENTADA DE SU ÉPOCA. ¿QUÉ FUE LO QUE LA HIZO TAN CÉLEBRE? ¿POR QUÉ OCASIONÓ 
                    Y SIGUE OCASIONANDO TANTOS DEBATES? CREO QUE, EN PARTE, ESTO SE DEBE A QUE FUE LA PRIMERA NOVELA 
                    ESCRITA POR UNA MUJER ANDINA INSERTADA EN EL CENTRO DE LA CIUDAD LETRADA QUE ENCARA ABIERTAMENTE 
                    LA ABYECTA SITUACIÓN DE LA POBLACIÓN INDÍGENA, QUE DESAFÍA LA CORRUPCIÓN DE LAS AUTORIDADES PROVINCIANAS 
                    Y QUE ASIGNA A LA MUJER EDUCADA EL ROL CIVILIZADOR DE MADRE REPUBLICANA <br>
                </p>
                <div class="col-sm-12 text-right">
                    <span class="fontMS300Italic text-white font-24">ROCÍO FERREIRA, 2005.<br><br></span>
                </div>
                <img id="img_rotate" src="\assets\images\general\LINEA_RESALTE_BLANCA.png">
            </div>
        </div>
    </div>
</div>
<div class="container_Blanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-37">
                            LUZ ENTRE SOMBRAS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS300 text-center colorPrincipal font-37">
                    REFLEXIONES EN TORNO <br>
                    A LA GUERRA DEL PACÍFICO
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br>
                    LA GUERRA DEL PACÍFICO (1879-1883) DEJÓ UNA SOCIEDAD EN PROFUNDA CRISIS. 
                    LOS ALTIBAJOS QUE ENFRENTA CLORINDA MATTO REVELAN UN PERÍODO TURBULENTO DE CONFLICTOS POLÍTICOS, 
                    DIFICULTADES ECONÓMICAS Y TENSIONES IDEOLÓGICAS.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-4">
                        <img class="img-fluid" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img010.jpg">
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS700 font-20">
                            <br><br>
                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">

                            <a href="http://hdl.handle.net/20.500.14428/79318 " target="_blank"
                                style="color: black; text-decoration: none;">
                                <i class="fas fa-file-alt font-22 p-3"></i>

                                LA VUELTA DEL RECLUTA <br>

                            </a>

                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            En <span class="fontMS700Italic"> Leyendas y recortes.</span> <br>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            Imprenta “La Equitativa”, 1893. <br>

                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">

                            <a href="http://hdl.handle.net/20.500.14428/79317 " target="_blank"
                                style="color: black; text-decoration: none;">
                                <i class="fas fa-file-alt font-22 p-3"></i>

                                LUZ ENTRE SOMBRAS

                            </a>

                            <br>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            En <span class="fontMS700Italic"> Leyendas y recortes.</span> <br>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            Imprenta “La Equitativa”, 1893. <br>

                            <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                <p class="fontMS100 text-justify font-24">
                    <br>
                    La guerra también abre nuevos espacios para las mujeres. Antes confinadas al espacio doméstico, las 
                    viudas y huérfanas de la Guerra del Pacífico tienen que salir a buscarse la vida. Clorinda Matto y las 
                    demás pensadoras del siglo XIX abogan por la educación y profesionalización de las mujeres mientras se 
                    desarrollan como maestras, escritoras, periodistas e intelectuales.
                    <br><br>
                    Clorinda Matto está presente en todos los espacios donde se estaba pensando el futuro del país. 
                    Imparte discursos en distinguidos foros intelectuales, dirige uno de los semanarios más importantes 
                    de la época e inicia sus propias veladas literarias donde le da prioridad a los temas de la mujer y 
                    lo andino. En las veladas de Clorinda Matto concurren Ricardo Palma y su hija Angélica, Juana Rosa 
                    Amézaga y su hermano Carlos Germán, Mercedes Cabello, Teresa González de Fanning, Lastenia Larriva de 
                    Llona y Carlos Rey de Castro, entre otros.
                </p>
            </div>
        </div>
    </div>
</div>
<div class="container_Gris_Img2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-40">
                            IMPRENTA “LA EQUITATIVA”
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada2.png">
                    </div>
                </div>
                <p class="fontMS500 font-24">
                    <br>
                    EN 1891, EN <span class="fontMS500Italic"> EL PERÚ ILUSTRADO</span>, ENTONCES DIRIGIDO POR CLORINDA MATTO, 
                    SE PUBLICA EL CUENTO <span class="fontMS500Italic">"MAGDALA"</span> DEL AUTOR BRASILEÑO ENRIQUE COELHO NETTO. ESTE ES TILDADO DE BLASFEMO POR 
                    LA IGLESIA. EN CONSECUENCIA, CLORINDA MATTO ES EXCOMULGADA, RENUNCIA A SU CARGO Y SUFRE LA CENSURA DE SUS OBRAS.

                </p>
                <p class="fontMS100 text-justify font-24">
                    No obstante, ella redobla sus esfuerzos por hacer escuchar su voz. Junto con su hermano David, 
                    compra una imprenta de última tecnología y funda “La Equitativa” en 1892.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-3">
                    </div>
                    <div class="col-sm-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79199" target="_blank" style="color: black;">
                            <img width="100%" class="img-fluid"
                                src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img011.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Clorinda Matto de Turner.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Muestrario de la imprenta “La Equitativa”, servida por señoras, fundada en
                                        febrero de 1892 por Clorinda Matto de Turner.
                                        <br>
                                    </span>
                                    La Equitativa, 1892.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79669" target="_blank" style="color: black;">
                            <img width="100%" class="imgNP_sp img-fluid"
                                src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img012.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Los Andes,
                                    </span>
                                    números 104-156, 1893-1894.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 mt-5 mb-3">
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5 libro text-right">
                        <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img013.jpg">
                        <p class="fontMS100 text-center">
                            Dibujo satírico en
                            <span class="fontMS500">
                            </span>
                            <span class="fontMS100Italic">
                                El Leguito Frai José. <br>
                            </span>
                            22 de mayo de 1895.
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify font-24">
                            Con la intención de crear empleos para las viudas y huérfanas de la Guerra del Pacífico. 
                            "La Equitativa" es atendida exclusivamente por mujeres. En esta imprenta, Clorinda 
                            reedita varias de sus obras y funda  <span class="fontMS100Italic">Los Andes</span>,
                            periódico bisemanal con difusión en provincias. En esta publicación muestra su apoyo 
                            a Andrés Avelino Cáceres, en el contexto de la guerra civil sostenida con Nicolás 
                            de Piérola. Este hecho provoca una reacción violenta. En 1895, los montoneros de 
                            Piérola destruyen la imprenta y arrasan su hogar. Clorinda Matto abandona el país 
                            y sus últimos quince años de vida los transcurre en el exilio.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container_Blanco_Img2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%" style="margin-bottom: 2%;"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 130%;margin-bottom: 0%;margin-top: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            “LA SUERTE DE UNA MUJER EN EL PERÚ”
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    EPISTOLARIO CON RICARDO PALMA
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%" style="margin-top: 2%;"
                        src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                </div>
                <div class="row">
                    <p class="fontMS500 text-center font-24">
                        <br>
                        LA BIBLIOTECA NACIONAL DEL PERÚ PRESERVA EN SUS REPOSITORIOS TREINTA Y UN CARTAS QUE CLORINDA
                        MATTO LE ESCRIBIÓ A RICARDO PALMA ENTRE 1883 Y 1897.
                        <br><br>
                        <img style="max-width: 200px;" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img015.jpg">
                    </p>
                </div>
                <p class="fontMS100 text-justify font-24">
                    Las cartas ofrecen un testimonio de primera mano de cómo, a fines del siglo XIX, una mujer con 
                    aspiraciones intelectuales como Clorinda Matto tiene que enfrentar numerosas dificultades por 
                    mantener su ideario. La presente selección epistolar capta los altibajos de su vida profesional y personal.
                    <br><br>
                    Como viuda, el tema económico fue una preocupación permanente. La docencia, el periodismo y la literatura 
                    aparecen como las tres posibilidades que tiene a la vista para ganarse la vida. Al mismo tiempo, las cartas 
                    son pruebas de los esfuerzos de la escritora por posicionarse dentro de los espacios intelectuales del país. 
                    En todo momento muestra una actitud abierta y franca frente a su distinguido interlocutor. En este sentido, 
                    la correspondencia presenta otra faceta del carácter de esta tenaz pensadora.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <p>
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <mdb-carousel class="carousel slide carousel-fade" [animation]="'fade'">
                            <mdb-carousel-item>
                                <a href="https://hdl.handle.net/20.500.14428/24622" target="_blank" style="color: inherit;">
                                    <div class="view w-100 libro">
                                        <img class="d-block w-100 img-fluid"
                                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img016a.jpg"
                                            alt="First slide">
                                        <div class="overlaya3">
                                            <p class="fontMS100 text-center">
                                                <span class="fontMS500">
                                                    <br>
                                                </span>
                                                <span class="fontMS100Italic">
                                                    Carta de Clorinda Matto a Ricardo Palma.
                                                    <br>
                                                </span>
                                                5 de diciembre de 1883.
                                            </p>
                                        </div>
                                        <br><br>
                                        <div class="mask flex-center" mdbWavesEffect></div>
                                    </div>
                                </a>
                            </mdb-carousel-item>
                            <mdb-carousel-item>
                                <a href="https://hdl.handle.net/20.500.14428/24771" target="_blank" style="color: inherit;">
                                    <div class="view w-100 libro">
                                        <img class="d-block w-100 img-fluid"
                                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img016b.jpg"
                                            alt="Second slide">
                                        <div class="overlaya3">
                                            <p class="fontMS100 text-center">
                                                <span class="fontMS500">
                                                    <br>
                                                </span>
                                                <span class="fontMS100Italic">
                                                    Carta de Clorinda Matto a Ricardo Palma.
                                                    <br>
                                                </span>
                                                26 de enero de 1884.
                                            </p>
                                        </div>
                                        <br><br>
                                        <div class="mask flex-center" mdbWavesEffect></div>
                                    </div>
                                </a>
                            </mdb-carousel-item>
                            <mdb-carousel-item>
                                <a href="https://hdl.handle.net/20.500.14428/24937" target="_blank" style="color: inherit;">
                                    <div class="view w-100 libro">
                                        <img class="d-block w-100 img-fluid"
                                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img016c.jpg"
                                            alt="Third slide">
                                        <div class="overlaya3">
                                            <p class="fontMS100 text-center">
                                                <span class="fontMS500">
                                                    <br>
                                                </span>
                                                <span class="fontMS100Italic">
                                                    Carta de Clorinda Matto a Ricardo Palma.
                                                    <br>
                                                </span>
                                                18 de julio de 1884.
                                            </p>
                                        </div>
                                        <br><br>
                                        <div class="mask flex-center" mdbWavesEffect></div>
                                    </div>
                                </a>
                            </mdb-carousel-item>
                            <mdb-carousel-item>
                                <a href="https://hdl.handle.net/20.500.14428/46793" target="_blank" style="color: inherit;">
                                    <div class="view w-100 libro">
                                        <img class="d-block w-100 img-fluid"
                                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img016d.jpg"
                                            alt="Fourth slide">
                                        <div class="overlaya3">
                                            <p class="fontMS100 text-center">
                                                <span class="fontMS500">
                                                    <br>
                                                </span>
                                                <span class="fontMS100Italic">
                                                    Carta de Clorinda Matto a Ricardo Palma.
                                                    <br>
                                                </span>
                                                2 de diciembre de 1886.
                                            </p>
                                        </div>
                                        <br><br>
                                        <div class="mask flex-center" mdbWavesEffect></div>
                                    </div>
                                </a>
                            </mdb-carousel-item>
                            <mdb-carousel-item>
                                <a href="https://hdl.handle.net/20.500.14428/21584" target="_blank" style="color: inherit;">
                                    <div class="view w-100 libro">
                                        <img class="d-block w-100 img-fluid"
                                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img016e.jpg"
                                            alt="Fifth slide">
                                        <div class="overlaya3">
                                            <p class="fontMS100 text-center">
                                                <span class="fontMS500">
                                                    <br>
                                                </span>
                                                <span class="fontMS100Italic">
                                                    Carta de Clorinda Matto a Ricardo Palma.
                                                    <br>
                                                </span>
                                                9 de junio de 1895.
                                            </p>
                                        </div>
                                        <br><br>
                                        <div class="mask flex-center" mdbWavesEffect></div>
                                    </div>
                                </a>
                            </mdb-carousel-item>
                            <mdb-carousel-item>
                                <a href="https://hdl.handle.net/20.500.14428/58316" target="_blank" style="color: inherit;">
                                    <div class="view w-100 libro">
                                        <img class="d-block w-100 img-fluid"
                                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO_img016f.jpg"
                                            alt="Sixth slide">
                                        <div class="overlaya3">
                                            <p class="fontMS100 text-center">
                                                <span class="fontMS500">
                                                    <br>
                                                </span>
                                                <span class="fontMS100Italic">
                                                    Carta de Clorinda Matto a Ricardo Palma.
                                                    <br>
                                                </span>
                                                17 de julio de 1897
                                            </p>
                                        </div>
                                        <br><br>
                                        <div class="mask flex-center" mdbWavesEffect></div>
                                    </div>
                                </a>
                            </mdb-carousel-item>
                        </mdb-carousel>
                    </div>
                    <div class="col-sm-4 p-5">
                        <p>
                            <br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container_Morado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <!-- <div class="col-sm-4">
                        <img class="img-fluid mb-3 pointer" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img008c.jpg">
                    </div> -->
                    <div class="col-sm-12">
                        <p class="text-white fontMS500 font-24">
                            Los libros de Clorinda Matto de Turner fueron prohibidos por la iglesia, su imprenta
                            destruida por las fuerzas de Nicolás de Piérola y ella misma fue objeto de ataques por otros
                            intelectuales.
                        </p>
                    </div>
                    <div class="col-sm-12 mb-5 mt-4">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿Cuáles son las posturas intelectuales de la autora? ¿Por qué crees que ciertos sectores
                            reaccionaron con tanta violencia a su obra?


                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            <span class="fontMS500Italic">Aves sin nido</span> es una novela que tiene como personajes
                            principales a mujeres, tales como Lucía y Margarita. ¿Cuál es la situación de las mujeres en
                            la novela? ¿Qué semejanzas y diferencias encuentras con la situación actual de las mujeres?

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            En tu opinión, ¿cuáles son los temas sociales más urgentes en la actualidad?

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container_Blanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio9\ET04_MS14_MATTO__LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 290%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio9\ET04_MS14_MATTO__LINEA1-recortada2.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100 font-24">
                            <br>
                            <span class="fontMS500">
                                Denegri, F. y Peluffo, A. (eds). (2020).<br>
                            </span>
                            <span class="fontMS100Italic">
                                Su afectísima discípula,Clorinda Matto de Turner: cartas a Ricardo Palma, 1883-1897.
                            </span>
                            Lima: PUCP. <br>
                            <a href="http://isbn.bnp.gob.pe/catalogo.php?mode=detalle&nt=112042" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100 font-24">
                            <br>
                            <span class="fontMS500 font-24">
                                Ferreira, R. (2005).
                            </span><br>
                            <span class="fontMS100Italic">
                                Clorinda Matto de Turner, novelista y los aportes de Antonio Cornejo Polar al estudio
                                de la novela peruana del siglo XIX.
                            </span>
                            En: Revista de Crítica Literaria Latinoamericana. Año 31 (62): p. 27-51. <br>
                            <a href="http://www.cervantesvirtual.com/obra-visor/clorinda-matto-de-turner-novelista-y-los-aportes-de-antonio-cornejo-polar-al-estudio-de-la-novela-peruana-del-siglo-xix/html/58c59d31-e36e-49ef-8e68-f304c454bd6d_3.html#I_0"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100 font-24">
                            <br>
                            <span class="fontMS500 font-24">VV.AA. (2018).</span><br>
                            <span class="fontMS100Italic">Clorinda Matto de Turner: Infatigable obrera del pensamiento.
                            </span> En: Libros & Artes.
                            Revista de cultura de la Biblioteca Nacional del Perú. Año 17(89-90): p. 2-9. <br>
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/libros-y-artes-89-90/2/"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 font-24">
                            <br>
                            <span class="fontMS500">Mannarelli, M.E. y Velásquez, D. (2020).</span><br>
                            <span class="fontMS100Italic">Palabra escrita, espacio público y política en
                                Clorinda Matto de Turner </span> En: Discursos Del Sur
                            (5): 91-120.<br>
                            <a href="https://revistasinvestigacion.unmsm.edu.pe/index.php/discursos/article/view/18143/15441"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100 font-24">
                            <br>
                            <span class="fontMS500 font-24">
                                Sotomayor, E. (ed). (2017).
                            </span>
                            <br>
                            <span class="fontMS100Italic">
                                Pensar en público: las veladas literarias de
                                Clorinda Matto en la Lima de la posguerra,
                                1887-1891.
                            </span>
                            Lima:
                            <br> BNP.<br>
                            <a href="https://dialnet.unirioja.es/servlet/articulo?codigo=6788030" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100 font-24">
                            <br>
                            <span class="fontMS500 font-24">
                                Ward, T. (2009).
                            </span>
                            <br>
                            <span class="fontMS100Italic">
                                Clorinda Matto de Turner y sus ideologías
                                nacionales.</span> <br> En: Buscando la nación peruana.
                            Lima: Editorial Horizonte, p. 156-174. <br>
                            <a href="http://www.cervantesvirtual.com/obra-visor/clorinda-matto-de-turner-y-sus-ideologias-nacionales/html/914d1b80-4f43-4309-bfc9-e06f95010787_6.html#I_0_"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>